// Compact chip that surfaces the destination country's post-study work
// visa envelope on every ResultCard / Shortlist row. Colour bands:
//   0 yrs        → red   ("no PSW")
//   1 - 1.5 yrs  → amber ("PSW Ny")
//   2 + yrs      → emerald ("PSW Ny")
//
// Returns null when the field is missing so we don't decorate rows with
// no data (rare — legacy directory-tier records).

const _COPY = {
  0:   { label: "no PSW",  hint: "No automatic post-study work visa. Only a short job-seeker visa (60-180 days) — most graduates need employer sponsorship or must return home." },
  1:   { label: "PSW 1y",  hint: "1-year post-study work visa (e.g. NL Zoekjaar, FR APS, SG LTVP). Non-renewable in most cases." },
  1.5: { label: "PSW 1.5y", hint: "18-month post-study Job Search Visa (Germany). Convertible to a work visa on job offer." },
  2:   { label: "PSW 2y",  hint: "2-year post-study work visa (UK Graduate Route / Ireland Third Level Graduate Programme). Convertible to a skilled-worker visa." },
  3:   { label: "PSW 3y",  hint: "3-year post-study work visa (some jurisdictions extend for STEM/regional programmes)." },
};

export default function PswChip({ years, size = "md" }) {
  if (years === null || years === undefined) return null;
  const n = Number(years);
  const key = _COPY[n] ? n : (n === 0 ? 0 : (n >= 2 ? 2 : (n >= 1.5 ? 1.5 : 1)));
  const meta = _COPY[key];
  const tone =
    n === 0     ? "bg-red-50 text-red-800 border-red-200"      :
    n >= 2      ? "bg-emerald-50 text-emerald-800 border-emerald-200" :
                  "bg-amber-50 text-amber-800 border-amber-200";
  const sizing = size === "sm"
    ? "text-[9px] px-1.5 py-0.5"
    : "text-[10px] px-2 py-0.5";
  return (
    <span
      data-testid={`psw-chip-${n === 0 ? "none" : String(n).replace(".", "_")}`}
      title={meta.hint}
      className={`inline-flex items-center gap-1 font-underground-sc tracking-wider rounded-full border ${sizing} ${tone}`}
    >
      {meta.label}
    </span>
  );
}
